// Use runtime SERVICE_URL from index.aspx instead of hardcoded value
// This allows the API URL to be configured on the server
declare var SERVICE_URL: string;

export const environment = {
  production: true,
  get apiUrl(): string {
    return typeof SERVICE_URL !== 'undefined' ? SERVICE_URL : 'http://localhost/FleetTrends';
  }
};
